import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getSession } from "../api";

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    getSession()
      .then((res) => {
        if (res.data.user) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      })
      .catch(() => setIsAuthenticated(false));
  }, []);

  // Mostra un loader finché non si conosce lo stato dell'utente
  if (isAuthenticated === null) {
    return <div>Caricamento...</div>;
  }

  // Se non è autenticato, lo rimanda al login
  if (!isAuthenticated) {
    return <Navigate to={`/?error=Sessione%20Utente%20Inesistente`} replace />;
  }

  // Se autenticato, mostra la pagina protetta
  return children;
};

export default ProtectedRoute;